// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__z_nUY","title":"Images90_title__3dlcQ","images":"Images90_images__JWxmQ"};